import { render, staticRenderFns } from "./RadioInput.vue?vue&type=template&id=f8fac308&lang=pug"
import script from "./RadioInput.vue?vue&type=script&lang=ts"
export * from "./RadioInput.vue?vue&type=script&lang=ts"
import style0 from "./RadioInput.vue?vue&type=style&index=0&id=f8fac308&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports